import { warn } from '@swivl-mono/helpers';
import { MemberInviteInterface } from '@swivl-mono/types';
import { Button, ButtonColor, Input } from '@swivl-mono/ui';
import { useState } from 'react';
import { NavigationHelper } from '../../../../Helpers/Navigation/Navigation.Helper';
import { Member } from '../../../../Models/Member/Member.Current';
import MembersModel from '../../../../Models/Member/Members.Model';
import ModalModel from '../../../../Models/Modal/Modal.Model';
import { AlertsModel } from '../../../../Models/Notifications/Alerts.Model';

export function MembersAddMemberModal() {
  const [partialInvite, setPartialInvite] = useState<Partial<MemberInviteInterface>>({
    email: '',
    firstName: '',
    lastName: '',
    orgId: Member.orgId,
    sentByMemberId: Member.id,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  return (
    <div>
      <label>First Name</label>
      <Input
        value={partialInvite.firstName}
        onChange={(e) =>
          setPartialInvite({ ...partialInvite, firstName: e.target.value })
        }
      />
      <label>Last Name</label>
      <Input
        value={partialInvite.lastName}
        onChange={(e) =>
          setPartialInvite({ ...partialInvite, lastName: e.target.value })
        }
      />
      <label>Email</label>
      <Input
        value={partialInvite.email}
        onChange={(e) =>
          setPartialInvite({ ...partialInvite, email: e.target.value })
        }
      />
      {error && <div className="text-red-500">{error}</div>}

      <div className="mt-5 pb-3 flex flex-row justify-end">
        <Button
          loading={loading}

          onClick={() => {
            ModalModel.hideModal();
          }}
          className="mr-2"
        >
          Cancel
        </Button>
        <Button
          color={ButtonColor.ORANGE}
          loading={loading}
          onClick={async () => {
            try {
              if (!partialInvite.email ||
                !partialInvite.firstName ||
                !partialInvite.lastName) {
                setError('Please fill out all fields');
                return;
              }

              const newInvite = await MembersModel.createInvite(partialInvite);
              AlertsModel.successToast('Invite sent');
              ModalModel.hideModal();
              NavigationHelper.navigate('settings/members/invite/' + newInvite.id);
            } catch (error: any) {
              warn(error, error.message);
              if (error.message) {
                setError(error.message);
              }
              setLoading(false);
            }
          }}
        >
          Send Invite
        </Button>
      </div>
    </div>
  );
}
